'use client';

import { useCallback } from 'react';
import { ToastAlert, useToast } from '@frameio/vapor';

export function useErrorToast() {
  const { addToast } = useToast();

  return useCallback(
    (title: string) => {
      addToast(
        (dismiss, closeLabel) => (
          <ToastAlert
            closeLabel={closeLabel}
            onRequestClose={dismiss}
            title={title}
            variant="error"
          />
        ),
        { duration: 4000 }
      );
    },
    [addToast]
  );
}
